var messages = {
  okText: '确定',
  cancelText: '取消'
};
export default messages;